import { Component, Input } from "@angular/core";
import { ConditionListsAgreementModel } from "../../../models/components/condition-lists-agreement.model";

@Component({
    selector: "pcg-ng-condition-lists-agreement",
    template: require('./condition-lists-agreement.component.html')
})
export class ConditionListsAgreementComponent {
    @Input()
    public agreement: ConditionListsAgreementModel;
}
